import { defineComponent as _defineComponent } from 'vue'
import LangSwitch from '@/components/lang/LangSwitch.vue';
import BreadcrumbsComponent from '../features/BreadcrumbsComponent.vue';
import UserData from "@/components/userData/UserData.vue";
import LoginPopUp from "@/components/layout/loginPopup/LoginPopUp.vue";
import LogoutKeplr from "@/components/layout/loginPopup/LogoutConfirm.vue";
import {SideBarIconType} from "@/services/permissions/sidebar.config";
import {useConfigurationStore} from '@/store/configuration.store';
import {changeTitle} from "@/utils/title-changer";
import {useRoute, useRouter} from 'vue-router';
import {computed, ref} from "vue";
import {useUserStore} from "@/store/user.store";
import {PermissionsService} from "@/services/permissions/permissions.service";
import KeplrLogo from '../commons/KeplrLogo.vue';
import * as GovernanceIcon from "@/components/commons/GovernanceIcon.vue";
import dataService from "@/services/data.service";
import {useUserServiceStore} from "@/store/userService.store";
import UserIcon from "@/components/features/UserIcon.vue";
import {useTokensStore} from "../../store/tokens.store";
import TokenPriceComponent from "@/components/TokenPriceComponent.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'AppHeader',
  setup(__props, { expose: __expose }) {
  __expose();

const router = useRouter();
const loginPopupStatus = ref(false);
const logoutPopupStatus = ref(false);
const dropdown = ref(false);

const toggleDropdown = () => {
  dropdown.value = !dropdown.value;
};
const configMap = computed(() => {
  return useConfigurationStore().getConfigList;
});
const curentNetwork = computed(() => {
  return useConfigurationStore().getConfigName;
});

const onChange = (event: any) => {
  useConfigurationStore().setNetwork(event.target.value);
  changeTitle();
  logoutPopupStatus.value = false;
};
const permissionsService = new PermissionsService();
const menu = computed(() => {
  return permissionsService.createSideBar();
});


const selected = computed(() => {
  let current = menu.value.find(element => element.href == router.currentRoute.value.path);
  return current?.id;
});

const currentRouteName = computed(() => {
  return router.currentRoute.value.name;
});
const displayLogo = () => {
  return useUserStore().connectionInfo.isKeplr() || useUserStore().connectionInfo.isLeap() || useUserStore().connectionInfo.isCosmostation();
};

const getLetter = () => {
  if(useUserStore().connectionInfo.isCosmostation()) {
    return 'C';
  } else if(useUserStore().connectionInfo.isKeplr()) {
    return 'K';
  } else if(useUserStore().connectionInfo.isLeap()) {
    return 'L';
  }
};

function openAccInfo() {
  logoutPopupStatus.value = !logoutPopupStatus.value;
}

function logoutWallet() {
  // const latestBlock = computed(() => useBlockStore().getLatestBlock);
  dataService.onLogOutWallet();
}

function logoutAccount(){
  useUserServiceStore().logoutAccount();
  router.push('/buyTokens/signIn');
}
const route= useRoute();
const onLogoClick = () => {

  if(route.name == 'Dashboard') {
    window.location.reload();
  } else {
    router.push({name: 'Dashboard'});
  }
};


const profileDropdown = ref(false);
const toggleProfileDropdown = () => {
  profileDropdown.value = !profileDropdown.value;
};

const closeProfileDropdown = () => {
  profileDropdown.value = false;
};

const __returned__ = { router, loginPopupStatus, logoutPopupStatus, dropdown, toggleDropdown, configMap, curentNetwork, onChange, permissionsService, menu, selected, currentRouteName, displayLogo, getLetter, openAccInfo, logoutWallet, logoutAccount, route, onLogoClick, profileDropdown, toggleProfileDropdown, closeProfileDropdown, LangSwitch, BreadcrumbsComponent, UserData, LoginPopUp, LogoutKeplr, get SideBarIconType() { return SideBarIconType }, get useConfigurationStore() { return useConfigurationStore }, get useUserStore() { return useUserStore }, KeplrLogo, GovernanceIcon, get useUserServiceStore() { return useUserServiceStore }, UserIcon }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})